var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopoverScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 9C32.8954 9 32 9.89543 32 11V23C32 24.1046 32.8954 25 34 25H40C41.1046 25 42 24.1046 42 23V11C42 9.89543 41.1046 9 40 9H34ZM40 30C41.1046 30 42 29.1046 42 28C42 26.8954 41.1046 26 40 26C38.8954 26 38 26.8954 38 28C38 29.1046 38.8954 30 40 30Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverScreen);
export default __webpack_public_path__ + "static/media/popoverScreen.f0419432024cc4e2ae3cae150fc2d7c2.svg";
export { ForwardRef as ReactComponent };